import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { useGetCode, useLogin } from '../../queries/auth';
import './styles.scss';
import { toast } from 'react-toastify';

export default function Login() {
  const navigate = useNavigate();
  const [cellphone, setCellphone] = useState<string>('');
  const [showCodeSection, setShowCodeSection] = useState<boolean>(false);
  const { mutate: getCodeRequest, data: codeData, error: codeError } = useGetCode();

  const { mutate: getLoginRequest, data: loginData, error: loginError } = useLogin();

  const handleLogin = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const {
      phone: { value: userCellphone },
    } = e.target as HTMLFormElement;

    setCellphone(userCellphone);
    getCodeRequest({
      cellphone: userCellphone,
    });
  };

  const handleSendCode = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const { code } = e.target as HTMLFormElement;

    getLoginRequest({
      cellphone,
      code: code.value,
      type: 'normal',
    });
  };

  useEffect(() => {
    if (codeData?.status === 200) {
      setShowCodeSection(true);
    }
  }, [codeData]);

  useEffect(() => {
    if (loginData) {
      Cookies.set('user', JSON.stringify(loginData), { expires: 30 });
      Cookies.remove('platform');
      navigate('/');
    }
  }, [loginData, navigate]);

  useEffect(() => {
    if (codeError) {
      toast(JSON.stringify(codeError));
    }
  }, [codeError]);

  useEffect(() => {
    if (loginError) {
      toast(JSON.stringify(loginError));
    }
  }, [loginError]);

  return (
    <div className="login-wrapper">
      {!showCodeSection && (
        <div className="login d-flex ui-fd-c">
          <span className="title">لاگین</span>
          <form
            className="d-flex ui-fd-c"
            onSubmit={handleLogin}
          >
            <label htmlFor="in-code">شماره تلفن</label>
            <input
              className="input"
              type="tel"
              name="phone"
              id="in-code"
            />
            <button className="btn">ورود</button>
          </form>
        </div>
      )}
      {showCodeSection && (
        <div className="signup d-flex ui-fd-c">
          <span className="title">کد</span>
          <form
            className="d-flex ui-fd-c"
            onSubmit={handleSendCode}
          >
            <label htmlFor="in-phone">کد را وارد کنید</label>
            <input
              className="input"
              type="tel"
              id="in-phone"
              name="code"
            />
            <button
              className="btn"
              type="submit"
              value="SIGN UP"
            >
              کد را وارد کنید
            </button>
            <button
              className="link mt-4"
              onClick={() => setShowCodeSection(false)}
            >
              اصلاح شماره
            </button>
          </form>
        </div>
      )}
    </div>
  );
}
